import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'
import _imports_1 from '@/assets/imgcaptions/icon_shangchuanS.svg'
import _imports_2 from '@/assets/imgcaptions/icon_filezip.svg'
import _imports_3 from '@/assets/imgcaptions/icon_gear.svg'
import _imports_4 from '@/assets/imgcaptions/icon_shalou.svg'


const _hoisted_1 = { class: "catProject" }
const _hoisted_2 = { class: "catProjectTop" }
const _hoisted_3 = { class: "topRout" }
const _hoisted_4 = { class: "catProjectToptext" }
const _hoisted_5 = { class: "catProjectBtm" }
const _hoisted_6 = { class: "catProjectBtmInner" }
const _hoisted_7 = { class: "innerLeft" }
const _hoisted_8 = { class: "innerLeftTop" }
const _hoisted_9 = { class: "iconLeftTop" }
const _hoisted_10 = { class: "abilityShowRow" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "abilityShowRow" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "formatLeftTop" }
const _hoisted_15 = { class: "supportTypeList" }
const _hoisted_16 = { class: "innerLeftBtm" }
const _hoisted_17 = {
  key: 0,
  class: "uploadBoxIconBox"
}
const _hoisted_18 = {
  key: 1,
  class: "uploadBoxShow"
}
const _hoisted_19 = { class: "uploadBoxShowInner" }
const _hoisted_20 = { class: "innerRight" }
const _hoisted_21 = { class: "innerRightIn" }
const _hoisted_22 = { class: "innerRightRow" }
const _hoisted_23 = { class: "catalogMainRout" }
const _hoisted_24 = { class: "textRout" }
const _hoisted_25 = { class: "innerRightRow" }
const _hoisted_26 = { class: "catalogMainSel" }
const _hoisted_27 = { class: "innerRightRow" }
const _hoisted_28 = { class: "titleRowSwitch" }
const _hoisted_29 = { class: "boxSwitch" }
const _hoisted_30 = { class: "catalogMainSwitch" }
const _hoisted_31 = { class: "rowSwitchOut" }
const _hoisted_32 = { class: "rowSwitch" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "rowSwitch" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "switchCustom" }
const _hoisted_37 = {
  key: 0,
  class: "innerRightRow"
}
const _hoisted_38 = { class: "titleRowKey" }
const _hoisted_39 = { class: "titleRowupText" }
const _hoisted_40 = { class: "catalogMainKey" }
const _hoisted_41 = {
  key: 1,
  class: "loadTareaBox"
}
const _hoisted_42 = {
  class: "innerRightRow",
  style: {"border":"none"}
}
const _hoisted_43 = { class: "catalogMain" }
const _hoisted_44 = { class: "innerRightBtn" }

import { ref, getCurrentInstance, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import { ElTree } from 'element-plus'
import {
    ArrowDown,
    ArrowUp,
    View,
    Delete,
    Close,
} from "@element-plus/icons-vue";
import axios from 'axios';
// 字节数长度
import { fileSizeNum } from '@/components/public-method/file-size'
// 引入路由模块
import routerBox from "@/components/common/routerBox.vue"
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue"
// 引入树形模块
import routTree from "./routTree.vue"
// 头部下拉列表
import type { CheckboxValueType } from 'element-plus'
// 引入上传文件进度页面
import resource from "./resource.vue"
// 引入下拉框
import menuPage from "@/components/common/menuPage.vue";
import selectBox from "./selectBox.vue"
import { useRouter,useRoute } from "vue-router";
import { applicationDetail ,aiIconRowOne ,aiIconRowTwo ,aitextOther} from "@/views/captions/icon.ts";
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { uploadCaptionFile } from "@/components/common/aiVoiceUploud.ts";
import { useChatStore } from "@/store/chatStore";
import VimConfig from "@/config/VimConfig";

export default /*@__PURE__*/_defineComponent({
  __name: 'project',
  setup(__props) {

const router = useRouter();
// 引入页面图标
const chatStore = useChatStore();
const route=useRoute()
let { proxy } = getCurrentInstance()
const token = Auth.getToken();
const durationTime=ref(0)
const menuShow=ref(false)
const mainBoxRef=ref()
const selectRef=ref()
const parentId = ref(0)
// 上传音视频
const upState = ref(false)
const upFilesize = ref(0)
const title = ref('')
const fileAv = ref()
const upFile = (file: any, files: any) => {
    console.log(file)
    console.log(file.name.length)
    upFilesize.value = file.size//文件大小
    if((file.size/1024/1024/1024)>10){
        ElMessage.error("请上传10G以内的文件!")
        return
    }
    if(file.name.length>100){
        ElMessage.error("文件名称不能超过100字符!")
        return
    }
    if (file.raw.type != "audio/wav" && file.raw.type != "audio/mpeg" && file.raw.type != 'video/mp4'&& file.raw.type != 'video/avi' 
    && file.raw.type != 'video/x-ms-wmv' && file.raw.type != 'application/x-shockwave-flash' && file.raw.type != 'video/x-ms-asf'
    && file.raw.type != 'video/quicktime'&& file.raw.type != 'video/3gpp'&& file.raw.type != 'video/x-matroska' && file.raw.type != 'video/mpeg' ) {
        ElMessage.error("请按照规定格式上传文件!")
        return
    }
    const filetype = file.type//文件类型
    title.value = file.name
    fileAv.value = file.raw
    upState.value = true


    const url = URL.createObjectURL(file.raw);
    
    console.log(url)
    const element = document.createElement(file.raw.type.startsWith('video/') ? 'video' : 'audio');
    element.src=url

    element.onloadedmetadata = () => {
        durationTime.value = element.duration;
        // urlUPdata.value=url
        console.log(durationTime.value)
        URL.revokeObjectURL(url); // 释放内存
    }

}
// 切换路由重置数据
watch(route, (to, from) => {
    parentId.value=0
    fileText.value=''
	title.value=''
    upState.value=false
    fileAv.value=null
    transSwitch.value=false
    selShow.value=false
    stylizaShow.value=false
    selstyliza.value=''
    hotWord.value=''
    durationTime.value=0
    maximumWordCount.value=14
    fileRoutText.value='根目录'
    language.value='cn'
    submitFunOnoff.value=false
    let captionTree=JSON.parse(localStorage.getItem('captionTree')) || []
    if(captionTree.length>0){
        for(let i=1;i<captionTree.length;i++){
            fileRoutText.value+= ('/' + captionTree[i].name)
        }
        parentId.value=captionTree[captionTree.length - 1].parentId
        console.log(fileRoutText.value)
    }else{
        fileRoutText.value ='根目录'
        parentId.value=0
    }
})
onMounted(() => {
  document.addEventListener("click", (event) => {
    closeAll()
    
  });
});
const delTreeThis=ref('')
onMounted(() => {
    languageChange('cn')
   

});
// 
const changeSelect=(e:any)=>{
    router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: e } })
}
const closeAll=()=>{
    treeListShow.value=false
    mainBoxRef.value?.closes()
    selectRef.value?.closes()
    // if(mainBoxRef.value!=undefined || mainBoxRef.value!=null||mainBoxRef.value.closes()!=undefined){
    //     mainBoxRef.value.closes();
    // }
    // if(selectRef.value!=undefined || selectRef.value!=null||selectRef.value.closes()!=undefined){
    //     selectRef.value.closes();
    // }
    
}
// 获取所有目录
const treeListShow = ref(false)

const opentreeList = () => {
    folderList()
    treeListShow.value = !treeListShow.value

}
const treeList = ref([{
    id: '0',
    label: '根目录',
    children: [],
}])
const folderList = () => {
    newCaptionApi.getFolderList().then((res) => {
        let resData = JSON.stringify(res.data).replaceAll("folderName", "label")
        treeList.value[0].children = (JSON.parse(resData))
        console.log(resData)
        console.log(treeList.value)
    })
}
const fileRoutText = ref('根目录')
const showParentRout = (data:any) => {
    treeListShow.value = false
    parentId.value = data[1]
    if(data[0].startsWith('/')){
        fileRoutText.value = data[0].replace('/', "")
    }
    
}
// 识别语言
const language = ref('cn')
const langStyle = {
    'background': 'rgba(238, 251, 255, 0.25)'
}
const translationLanguage = ref('')//语言类型
const selstyliza=ref('')//选择语言风格
const dataCustom=ref('')//自定义风格
const languageList = ref([
    { text: '韩语', value: 'ko' },
    { text: '法语', value: 'fr' },
    { text: '德语', value: 'de' },
    { text: '俄语', value: 'ru' },
    { text: '泰语', value: 'th' },
    { text: '西班牙语', value: 'es' },
    { text: '意大利语', value: 'it' },
    { text: '日语', value: 'ja' },
])
const stylizaList = ref([
    { text: '通用', value: '' },
    { text: '历史', value: '历史' },
    { text: '武侠', value: '武侠' },
    { text: '都市', value: '都市' },
    { text: '家庭', value: '家庭' },
    { text: '科幻', value: '科幻' },
    { text: '罪案悬疑', value: '罪案悬疑' },
    { text: '青春校园', value: '青春校园' },
    { text: '自定义', value: '自定义' },
])
const languageChange = (type: string) => {
    language.value = type
    let obj = { text: '中文', value: 'cn' }
    let objen = { text: '英语', value: 'en' }
    if (language.value == "en") {
        languageList.value.pop()
        languageList.value.push(obj)
    } else {
        languageList.value.pop()
        languageList.value.push(objen)
    }

}
// ai翻译
const transSwitch=ref(false)
const selShow=ref(false)//语言下拉框展示
const stylizaShow=ref(false)//自定义风格展示
const changeSwitch=(value:any)=>{
    console.log(value)
    translationLanguage.value=''
    selstyliza.value=''
    if(value) selShow.value=true
    if(!value) selShow.value=false
    stylizaShow.value=false
}
const changeselstyliza=()=>{
    console.log(selstyliza.value)
    dataCustom.value=''
    if(selstyliza.value=='自定义') stylizaShow.value=true
    if(selstyliza.value!='自定义') stylizaShow.value=false
}
// 生成热词
const identifyLoad=ref(false)//生成热词等待
const hotWord=ref('')
const createKey = (file: any, fileList: any) => {
    // console.log(file)
    const isLtM = file.raw.size / 1024 / 1024;
    // console.log(isLtM)
    if (isLtM > 5) {
        ElMessage.error("请上传5M以内的文件!");
        return false
    }
    fileText.value = file.raw
    submitUpload()
}
const fileText = ref()//热词识别文件
const submitUpload = () => {
    // console.log('提交上传文件')
    // console.log(fileText.value)
    identifyLoad.value = true
    if (fileText.value == undefined || fileText.value == '' || fileText.value == null) {
        ElMessage.error("请上传文件!");
        return
    }

    const formDatas = new FormData();
    formDatas.append('auxiliaryFile', fileText.value);

    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/subtitle/upload/auxiliary/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(function (data) {
            console.log(data);
            if (data.code == 200) {
                hotWord.value = data.data.result
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            identifyLoad.value = false

        })
}
const maximumWordCount=ref('14')//每行最多字数
// 提交上传文件
const submitFunOnoff=ref(false)
const submitFun =()=>{
    console.log('提交上传文件'+parentId.value)
    let translationStyle
    if(selstyliza.value=='自定义'){
        translationStyle=dataCustom.value
    }else{
        translationStyle=selstyliza.value
    }
    if(submitFunOnoff.value ||fileAv.value==null){
        return
    }
    submitFunOnoff.value=true
    newCaptionApi.addAi(hotWord.value, language.value, maximumWordCount.value, parentId.value, title.value, translationLanguage.value,translationStyle)
        .then((res) => {
            console.log(res)
            const id = res.data
            const taskId = res.data; // 生成唯一任务ID
            uploadCaptionFile(fileAv.value, taskId);
            router.push("/index/aiApply/projectList")
        })
}


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logoImg",
          onMousemove: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(applicationDetail).caption.name) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(applicationDetail).caption.version), 1)
      ]),
      _createVNode(selectBox, {
        ref_key: "selectRef",
        ref: selectRef,
        class: "selecTostyle",
        newShow: false,
        allShow: true,
        onChangeSelect: changeSelect
      }, null, 512),
      _createVNode(mainBox, {
        class: "topMain",
        ref_key: "mainBoxRef",
        ref: mainBoxRef,
        onCloseAll: closeAll
      }, null, 512),
      _withDirectives(_createVNode(menuPage, {
        class: "menuPageStyle",
        onClosemenu: _cache[1] || (_cache[1] = ($event: any) => (menuShow.value=false)),
        onOpenmenu: _cache[2] || (_cache[2] = ($event: any) => (menuShow.value=true)),
        nameInfo: _unref(applicationDetail).caption
      }, null, 8, ["nameInfo"]), [
        [_vShow, menuShow.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "titleLeftTop" }, "AI字幕全新升级", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiIconRowOne), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "abilityShowOne",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: item.icon
                    }, null, 8, _hoisted_11),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiIconRowTwo), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "abilityShowOne",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: item.icon
                    }, null, 8, _hoisted_13),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "supportTypeTitle" }, [
                _createElementVNode("span", { class: "supportTypeTitleText" }, "支持视频格式"),
                _createElementVNode("span", { class: "supportTypeTitleLine" })
              ], -1)),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aitextOther), (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_upload, {
              class: "upload-demo",
              drag: "",
              "show-file-list": false,
              multiple: "",
              "auto-upload": false,
              onChange: upFile
            }, {
              default: _withCtx(() => [
                (!upState.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[17] || (_cache[17] = [
                      _createElementVNode("div", { class: "uploadBoxIcon" }, [
                        _createElementVNode("div", { class: "iconBox" }, [
                          _createElementVNode("div", { class: "iconInner" }, [
                            _createElementVNode("img", { src: _imports_1 })
                          ]),
                          _createElementVNode("div", { class: "iconInnerText" }, [
                            _createElementVNode("div", { class: "iconInnerTextTop" }, "点击或拖拽 音视频文件 到这里上传"),
                            _createElementVNode("div", { class: "iconInnerTextBtm" }, "*最大支持 10 GB文件上传")
                          ])
                        ])
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (upState.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[18] || (_cache[18] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(title.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_scrollbar, { height: "100%" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "titleRow" }, " 目录 ", -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(fileRoutText.value), 1),
                    _createVNode(_component_el_tooltip, {
                      content: "文件路径",
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_3,
                          onClick: _withModifiers(opentreeList, ["stop"])
                        })
                      ]),
                      _: 1
                    }),
                    (treeListShow.value)
                      ? (_openBlock(), _createBlock(routTree, {
                          key: 0,
                          data: treeList.value,
                          class: "routTreestyle",
                          onUpparentId: showParentRout,
                          onCloseThis: _cache[3] || (_cache[3] = ($event: any) => (treeListShow.value = false)),
                          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "titleRow" }, " 识别语言 ", -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", {
                      class: "cnBtn",
                      style: _normalizeStyle(language.value == 'cn' ? langStyle : ''),
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ( languageChange('cn')), ["stop"]))
                    }, " 中文 ", 4),
                    _createElementVNode("span", {
                      class: "enBtn",
                      style: _normalizeStyle(language.value == 'en' ? langStyle : ''),
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (languageChange('en')), ["stop"]))
                    }, " 英文 ", 4)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[21] || (_cache[21] = _createTextVNode(" AI字幕翻译 ")),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_unref(ElSwitch), {
                        modelValue: transSwitch.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((transSwitch).value = $event)),
                        onChange: changeSwitch
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "titleSwitch" }, "目标语种", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((translationLanguage).value = $event)),
                          class: "toselect",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.value,
                              key: index
                            }, _toDisplayString(item.text), 9, _hoisted_33))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, translationLanguage.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "titleSwitch" }, "翻译风格", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selstyliza).value = $event)),
                          class: "toselect",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                          onChange: changeselstyliza
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stylizaList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.value,
                              key: index
                            }, _toDisplayString(item.text), 9, _hoisted_35))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, selstyliza.value]
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("textarea", {
                        style: {"width":"100%"},
                        rows: 8,
                        type: "textarea",
                        class: "textareaCustomBox",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dataCustom).value = $event)),
                        placeholder: "请输入风格内容，例如：\n\n欧式言情，旧时代，童话，夸张"
                      }, null, 512), [
                        [_vModelText, dataCustom.value]
                      ])
                    ], 512), [
                      [_vShow, stylizaShow.value]
                    ])
                  ], 512), [
                    [_vShow, selShow.value]
                  ])
                ]),
                (language.value == 'cn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "titleRowKeyTitle" }, [
                          _createTextVNode(" 关键词优化 "),
                          _createElementVNode("span", null, "(提升识别准确率)")
                        ], -1)),
                        _createElementVNode("div", _hoisted_39, [
                          (language.value == 'cn')
                            ? (_openBlock(), _createBlock(_component_el_upload, {
                                key: 0,
                                ref: "uploadRef",
                                class: "upload-demo",
                                "show-file-list": false,
                                "auto-upload": false,
                                "on-change": createKey
                              }, {
                                trigger: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createElementVNode("span", null, "上传文件", -1),
                                  _createElementVNode("span", { class: "upTextIcon" }, "?", -1)
                                ])),
                                _: 1
                              }, 512))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        (!identifyLoad.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              style: {"width":"100%"},
                              rows: 8,
                              type: "textarea",
                              class: "textareaKey",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((hotWord).value = $event)),
                              placeholder: "请输入热词，建议输入人物姓名、事物名称、专业词汇、等自定义词汇\n例如：\n唐昭帝，天狼泉，地塞米松，十动然拒 .."
                            }, null, 512)), [
                              [_vModelText, hotWord.value]
                            ])
                          : _createCommentVNode("", true),
                        (identifyLoad.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[26] || (_cache[26] = [
                              _createElementVNode("div", { class: "loadTarea" }, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("img", {
                                    src: _imports_4,
                                    alt: ""
                                  })
                                ]),
                                _createElementVNode("span", null, "文件分析中")
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_42, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "titleRow" }, " 每行字幕最多字数(10~100个) ", -1)),
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((maximumWordCount).value = $event)),
                      class: "rowInput"
                    }, null, 512), [
                      [_vModelText, maximumWordCount.value]
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_el_button, {
                type: "primary",
                color: "rgba(32,124,246,0.9)",
                style: {"width":"180px"},
                onClick: _withModifiers(submitFun, ["stop"])
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("提交项目")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})